<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right">
          <app-form-buttons [submitting]="submitting" [disabled]="!selected" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>


    <div class="p-grid p-fluid">
        <div class="p-col-12 p-md-5">
          <h3>{{ t('common.labels.choose_template') }}</h3>
          <p-table *ngIf="loading !== true" [value]="templates" [paginator]="true" [rows]="10" selectionMode="single" [(selection)]="selected" (onRowSelect)="onTemplateSelect($event)" (onRowUnselect)="onTemplateUnselect($event)" dataKey="id" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
                <tr>
                  <th>{{ t('common.labels.name') }}</th>
                  <th>{{ t('common.labels.language') }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-template>
                <tr class="tr-hover" [pSelectableRow]="template">
                  <td>{{template.name}} <fa-icon *ngIf="template === selected" [icon]="faCheck" class="p-ml-2"></fa-icon></td>
                  <td>{{ t(template.getLanguageName()) }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td class="no-data" colspan="2">{{ t('common.texts.no_templates') }}</td>
              </tr>
            </ng-template>
          </p-table>
          <app-loader [loading]="loading"></app-loader>
        </div>

        <div class="p-col-12 p-md-1">
          <p-divider layout="vertical" type="dashed"></p-divider>
        </div>

        <div class="p-col-12 p-md-6">
          <h3 *ngIf="selected === null">{{ t('common.labels.create_new') }}</h3>
          <h3 *ngIf="selected?.id !== null">{{ t('common.labels.create_new_from', { value: selected.name }) }}</h3>
          <h3 *ngIf="selected !== null && selected?.id === null">{{ t('common.labels.create_individual_procedure') }}</h3>

          <app-form-control #name [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')"></app-form-control>
          <app-form-control [cid]="'dispatcher'" [control]="form.get('dispatcher')" [type]="'select'" [options]="dispatchers" optionLabel="fullname_reverse" [label]="t('common.labels.dispatcher')"></app-form-control>
          <app-form-control withFeature="customers" [cid]="'customer'" [control]="form.get('customer')" [type]="'select'" [options]="customers" optionLabel="name" [label]="t('common.labels.customer')" [showClear]="true"></app-form-control>
          <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="languages" [label]="t('common.labels.language')"></app-form-control>
          <app-form-control [cid]="'ratingtype'" [control]="form.get('ratingtype')" [type]="'select'" [options]="ratingtypes" [optionLabel]="'name.' + transloco.getActiveLang().toUpperCase()" [label]="t('common.labels.ratingtype')"></app-form-control>
          <app-form-control [cid]="'start_time'" [control]="form.get('start_time')" [type]="'date'" [label]="t('common.labels.date') + getDstLabel()" [minDate]="minDate"></app-form-control>
          <app-form-control [cid]="'location_type'" [control]="form.get('location_type')" [type]="'select'" [options]="locationTypes" [label]="t('common.labels.type')"></app-form-control>
          <ng-container *ngIf="isLocationTypeSet() && !isVirtual()">
            <app-form-control [cid]="'location_name'" [control]="form.get('location_name')" [type]="'input'" [label]="t('common.labels.place')"></app-form-control>
          </ng-container>
          <app-country-timezone [edit]="true" [required]="true" [(country)]="country" [(timezone)]="timezone" [form]="this.form.get('tz')"></app-country-timezone>
          <ng-container *ngIf="isLocationTypeSet() && isVirtual()">
            <h3>{{ t('common.labels.conference_dial_in') }}</h3>
            <app-form-control [cid]="'conference_url'" [control]="form.get('conference_url')" [type]="'input'" [label]="t('common.labels.url')"></app-form-control>
            <app-form-control [cid]="'conference_info'" [control]="form.get('conference_info')" [type]="'textarea'" [label]="t('common.labels.informations')"></app-form-control>
          </ng-container>
          <h3>{{ t('common.labels.settings') }}</h3>
          <app-form-control [cid]="'documents_visible_observer'" [control]="form.get('documents_visible_observer')" [type]="'checkbox'" [label]="t('ac_basedata.documents_visible_observer')"></app-form-control>

        </div>
      </div>

  </form>
</ng-container>
